/* eslint-disable import/prefer-default-export -- a registry of named links, meant to grow */
// Off-site destinations linked from several places. One definition each: the
// group-subscriptions link had drifted into three spellings across eight call
// sites, two of them a page that no longer exists (Trello #1605), and the
// SPEC-052 Funnel C cutover will move it again.

// The institutional / group learning enquiry page (Leadpages). Bare form —
// the trailing-slash variant answers with a 308 to this one.
export const GROUP_SUBSCRIPTION_INFO_URL =
  'https://pages.stanwinstonschool.com/group-subscription-info-request-v2-swsca'
